import { __assign } from "tslib";
import { Field, Form, withFormik } from 'formik';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import FadeIn from 'react-fade-in';
import InputMask from 'react-input-mask';
import { Error } from '../../../../components';
import { AddressTypes, } from '../../../../stores/DetailsStore';
import { CheckAddress } from './components/CheckAddress';
import { detailsSchema } from './components/detailsSchema';
var DetailsForm = observer(function (props) {
    var appStore = props.appStore, config = props.config, errors = props.errors, touched = props.touched, values = props.values, setFieldValue = props.setFieldValue;
    var sharedAddressFormProps = {
        errors: errors,
        levelTypes: props.checkAddressStore.levelTypes,
        states: props.checkAddressStore.states,
        streetTypes: props.checkAddressStore.streetTypes,
        touched: touched,
        unitTypes: props.checkAddressStore.unitTypes,
        setFieldValue: setFieldValue,
        values: values,
    };
    var headingInfo = function (wCode) {
        switch (wCode) {
            case 'TOM':
                return (React.createElement("p", { className: "small" },
                    "Tomi respects your privacy. View our",
                    ' ',
                    React.createElement("a", { target: "_blank", href: "/privacy-policy" }, "Privacy Policy")));
            case 'EA':
                return (React.createElement("p", { className: "small" },
                    "Our",
                    ' ',
                    React.createElement("a", { target: "_blank", href: "//www.energyaustralia.com.au/privacy" }, "privacy policy"),
                    ' ',
                    "and",
                    ' ',
                    React.createElement("a", { target: "_blank", href: "//www.energyaustralia.com.au/creditstatement" }, "credit information statement"),
                    ' ',
                    "explain how we use and disclose your personal and credit information, your rights to access your information and the credit reporting bodies that we exchange information with."));
            case 'BDF':
                return (React.createElement("p", { className: "small" },
                    "Acurus respects your privacy. View our",
                    ' ',
                    React.createElement("a", { target: "_blank", href: "https://acurus.com.au/privacy-policy/" }, "Privacy Policy")));
            case 'ISPX':
                return (React.createElement("p", { className: "small" },
                    "Coles respects your privacy. View our",
                    ' ',
                    React.createElement("a", { target: "_blank", href: "https://osu-ispx-prd.aws.anex.com.au" }, "Privacy Policy")));
            case 'PB':
                return (React.createElement("p", { className: "small" },
                    "Pronto Broadband respects your privacy. View our",
                    ' ',
                    React.createElement("a", { target: "_blank", href: "https://prontobroadband.com.au" }, "Privacy Policy")));
            case 'CTL':
                return (React.createElement("p", { className: "small" },
                    "Commtel respects your privacy. View our",
                    ' ',
                    React.createElement("a", { target: "_blank", href: "https://commtel.com.au" }, "Privacy Policy")));
            default:
                return (React.createElement("p", { className: "small" },
                    "We respects your privacy. View our",
                    ' ',
                    React.createElement("a", { target: "_blank", href: "/privacy-policy" }, "Privacy Policy")));
        }
    };
    return (React.createElement(Form, null,
        headingInfo(props.config.wholesaleCustomerCode),
        React.createElement("div", { className: "form-group" },
            React.createElement("label", { htmlFor: "isBusiness", className: "checkbox checkbox-square" },
                React.createElement(Field, { id: "isBusiness", name: "isBusiness", type: "checkbox", checked: values.isBusiness }),
                React.createElement("small", { className: "label" }, "I am a business"))),
        values.isBusiness && (React.createElement("div", { className: "row" },
            React.createElement("div", { className: "col-md-6 form-group" },
                React.createElement("label", { htmlFor: "businessName" }, "Business Name"),
                React.createElement(Field, { id: "businessName", name: "businessName", component: "input", className: "form-control shadow-alt " + (errors.businessName &&
                        touched.businessName &&
                        'error') }),
                React.createElement(Error, { name: "businessName" })),
            React.createElement("div", { className: "col-md-6 form-group" },
                React.createElement("label", { htmlFor: "abn" },
                    "ABN ",
                    React.createElement("small", null, "(required if providing a Business name)")),
                React.createElement(Field, { id: "abn", name: "abn", component: "input", className: "form-control shadow-alt " + (errors.abn &&
                        touched.abn &&
                        'error') }),
                React.createElement(Error, { name: "abn" })))),
        React.createElement("div", { className: "row" },
            props.config.wholesaleCustomerCode === 'CTL' ? (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "col-md-6" },
                    React.createElement("div", { className: "form-group" },
                        React.createElement("label", { htmlFor: "externalId" }, "Partner Code"),
                        React.createElement(Field, { id: "externalId", name: "externalId", component: "input", className: "form-control shadow-alt", placeholder: "Please enter partner code...", onBlur: function (e) {
                                setFieldValue('externalId', e.currentTarget.value.trim());
                            } }))),
                React.createElement("div", { className: "col-md-6" }))) : (''),
            React.createElement("div", { className: "col-md-2" },
                React.createElement("div", { className: "form-group" },
                    React.createElement("label", { htmlFor: "title" }, "Title"),
                    React.createElement(Field, { id: "title", name: "title", component: "select", className: "form-control shadow-alt " + (errors.title &&
                            touched.title &&
                            'error') },
                        React.createElement("option", { value: "" }),
                        [
                            { display: 'Mr', value: 'Mr' },
                            { display: 'Mrs', value: 'Mrs' },
                            { display: 'Miss', value: 'Miss' },
                            { display: 'Ms', value: 'Ms' },
                            { display: 'Mx', value: 'Mx' },
                            { display: 'Dr', value: 'Dr' },
                        ].map(function (option) { return (React.createElement("option", { key: option.value, value: option.value }, option.display)); })),
                    React.createElement(Error, { name: "title" }))),
            React.createElement("div", { className: "col-md-5" },
                React.createElement("div", { className: "form-group" },
                    React.createElement("label", { htmlFor: "firstName" }, "First Name"),
                    React.createElement(Field, { id: "firstName", name: "firstName", component: "input", className: "form-control shadow-alt " + (errors.firstName &&
                            touched.firstName &&
                            'error'), placeholder: "Please enter your first name...", onBlur: function (e) {
                            setFieldValue('firstName', e.currentTarget.value.trim());
                        } }),
                    React.createElement(Error, { name: "firstName" }))),
            React.createElement("div", { className: "col-md-5" },
                React.createElement("div", { className: "form-group" },
                    React.createElement("label", { htmlFor: "lastName" }, "Last Name"),
                    React.createElement(Field, { id: "lastName", name: "lastName", component: "input", className: "form-control shadow-alt " + (errors.lastName &&
                            touched.lastName &&
                            'error'), placeholder: "Please enter your last name...", onBlur: function (e) {
                            setFieldValue('lastName', e.currentTarget.value.trim());
                        } }),
                    React.createElement(Error, { name: "lastName" })))),
        React.createElement("div", { className: "form-group" },
            React.createElement("label", { htmlFor: "emailAddress" }, "Email Address"),
            React.createElement(Field, { id: "emailAddress", name: "emailAddress", component: "input", className: "form-control shadow-alt " + (errors.emailAddress &&
                    touched.emailAddress &&
                    'error'), placeholder: "Please enter your email address..." }),
            props.config.wholesaleCustomerCode === 'EA' ? (React.createElement("p", { className: "small" }, "Your bills and correspondence will be sent to this email address.")) : (''),
            React.createElement(Error, { name: "emailAddress" })),
        React.createElement("div", { className: "form__wrap form__wrap_inner form__wrap_inner_last" },
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col-md-6" },
                    React.createElement("label", { htmlFor: "phoneNumber" }, "Phone"),
                    React.createElement("div", { className: "input-group" },
                        React.createElement("div", { className: "input-group-btn" },
                            React.createElement("div", { className: "select-pinned pinned-left" },
                                React.createElement(Field, { id: "phoneType", name: "phoneType", component: "select", className: "form-control", style: { minWidth: '120px' } },
                                    React.createElement("option", { value: "mobile" }, "Mobile"),
                                    React.createElement("option", { value: "home" }, "Home"),
                                    React.createElement("option", { value: "work" }, "Work")))),
                        React.createElement(Field, { id: "phoneNumber", name: "phoneNumber", component: "input", className: "form-control shadow-alt " + (errors.phoneNumber &&
                                touched.phoneNumber &&
                                'error'), placeholder: "Phone" })),
                    React.createElement(Error, { name: "phoneNumber" }),
                    React.createElement("div", { id: "element" })),
                React.createElement("div", { className: "col-md-6 form-group" },
                    React.createElement("label", { htmlFor: "dateOfbirth" }, "Date of birth"),
                    React.createElement(Field, { id: "dateOfBirth", name: "dateOfBirth", render: function (field) { return (React.createElement(InputMask, __assign({}, field.field, { className: "form-control shadow-alt " + (errors.dateOfBirth &&
                                touched.dateOfBirth &&
                                'error'), mask: "99/99/9999", placeholder: "DD/MM/YYYY" }))); } }),
                    React.createElement(Error, { name: "dateOfBirth" })))),
        React.createElement("hr", null),
        React.createElement("label", { htmlFor: "billingAddressRequired", className: "checkbox checkbox-square" },
            React.createElement(Field, { id: "billingAddressRequired", name: "billingAddressRequired", type: "checkbox", checked: values.billingAddressRequired }),
            React.createElement("small", { className: "label" },
                "My",
                ' ',
                props.config.wholesaleCustomerCode === 'EA' ? 'postal' : 'billing',
                ' ',
                "address is different to my service address")),
        values.billingAddressRequired && (React.createElement(FadeIn, null,
            React.createElement(CheckAddress, __assign({}, sharedAddressFormProps, { type: AddressTypes.Billing, label: props.config.wholesaleCustomerCode === 'EA'
                    ? 'Postal address details'
                    : 'Billing address details' })))),
        React.createElement("hr", null),
        React.createElement("label", { htmlFor: "deliveryAddressRequired", className: "checkbox checkbox-square" },
            React.createElement(Field, { id: "deliveryAddressRequired", name: "deliveryAddressRequired", type: "checkbox", checked: values.deliveryAddressRequired }),
            React.createElement("small", { className: "label" }, "My delivery address is different to my service address")),
        values.deliveryAddressRequired && (React.createElement(FadeIn, null,
            React.createElement(CheckAddress, __assign({}, sharedAddressFormProps, { type: AddressTypes.Delivery, label: 'Delivery address details' })))),
        props.config.wholesaleCustomerCode === 'EA' && (React.createElement("p", { className: "small" },
            "If you would like to add an authorised representative, complete the form",
            ' ',
            React.createElement("a", { target: "_blank", href: "https://www.energyaustralia.com.au/sites/default/files/2018-02/authorised-representative-form.pdf" }, "here"),
            ", and send a signed copy to",
            ' ',
            React.createElement("a", { target: "_blank", href: "//www.nbnsupport@energyaustralia.com.au" }, "nbnsupport@energyaustralia.com.au."),
            ' ')),
        React.createElement("section", { className: "footer-buttons" },
            React.createElement("button", { type: "button", className: "btn btn-shade btn-back", onClick: appStore.previousStep }, "Back"),
            React.createElement("button", { type: "submit", className: "btn btn-next" }, "Next"))));
});
export var Details = inject('config', 'checkAddressStore', 'appStore', 'detailsStore')(withFormik({
    handleSubmit: function (values, bag) {
        bag.props.detailsStore.setDetailsFromForm(values);
        bag.props.appStore.nextStep();
    },
    mapPropsToValues: function (_a) {
        var detailsStore = _a.detailsStore;
        return detailsStore.details.formValues
            ? detailsStore.details.formValues
            : detailsStore.details.formInitialValues;
    },
    validationSchema: function () { return detailsSchema; },
})(DetailsForm));
//# sourceMappingURL=Details.js.map